import { render, staticRenderFns } from "./AppCountDown.vue?vue&type=template&id=f85fcdfc&scoped=true&"
import script from "./AppCountDown.vue?vue&type=script&lang=js&"
export * from "./AppCountDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85fcdfc",
  null
  
)

export default component.exports